import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class NavigationService {
	currentRouteName$: BehaviorSubject<string> = new BehaviorSubject<string>('Dashboard');
	currentRouteId$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

	constructor(private _router: Router) {
		this._router.events
			.pipe(filter((event) => event instanceof NavigationStart))
			.subscribe();
	}

	emitNextRoute(route: string, routeId: number): void {
		this.currentRouteName$.next(route);
		this.currentRouteId$.next(routeId);
	}
}
